/*
 * @Description: 全局方法
 * @Author: jml
 * @Date: 2019-05-07 10:22:09
 * @LastEditTime: 2024-05-11 15:21:54
 */
import { Message, MessageBox, Loading } from 'element-ui';
import xrkDialogJs from '@/components/Dialog/main.js';
import axios from 'axios'; // 不要删

import QRCode from 'qrcode';
import dateFormat from '@/tools/dateFormat';
import {
  checkQuestionnaireIsAlikeAjax,
  clientVersion,
  checkCopyProjectBIConfigs as checkCopyProjectBIConfigsAjax
} from '@/api/ajax';
import Config from '@/config';
import { getToken } from '@/tools/auth';
import request from '@/tools/request'; // 不要删
export { toRecord, toAssign } from './jump';
import { download } from 'xrk-tools';
import Clipboard from 'clipboard';

function dealUrl(url, query) {
  if (!url) {
    throw new Error('对象必须包含url');
  }
  const _query = Object.keys(query).reduce((pre, cur) => {
    (query[cur] || query[cur] === 0 || query[cur] === '0') &&
      (pre[cur] = query[cur]);
    return pre;
  }, {});
  let strQuery = JSON.stringify(_query)
    .replace(/\{|\}|\"/g, '')
    .replace(/\,/g, '&')
    .replace(/\:/g, '=');
  strQuery = strQuery ? `?${strQuery}` : '';

  const _url = url + strQuery;
  window.open(_url, '_blank');
}

/**
 * 导出
 * @param {*} url
 * @param {*} query
 */
export const exportFile = (url, query = {}) => {
  dealUrl(url, query);
};

/**
 * 下载文件
 * @param {*} fileName
 * @param {*} content
 */
export const downloadFile = async (
  url,
  useResponseFileName,
  fileName,
  method,
  contentType,
  data
) => {
  return new Promise(async (resolve, reject) => {
    const loading = Loading.service({ fullscreen: true, text: '下载中...' });
    try {
      const res = await download.downloadFile(url, {
        fileName: fileName,
        useResponseFileName: useResponseFileName,
        tokenName: Config.token,
        requestTokenName: Config.token,
        method: method || 'get',
        contentType,
        data
      });
      try {
        if (res.status == 0) {
          Message.error(res.message);
        }
      } catch (error) {}
      resolve(res);
    } catch (e) {
      Message.error('下载失败');
      reject();
    }
    loading.close();
  });
};

/**
 * 链接转为二维码
 * @param {*} url
 */
export const getQrcodeUrl = url => {
  const canvas = document.createElement('canvas');
  let backUrl = '';
  QRCode.toCanvas(canvas, url, error => {
    if (error) console.error(error);
    backUrl = canvas.toDataURL('image/png', 1);
  });
  return backUrl;
};

/**
 * 是否小于当前月份
 */
export const isAgo = month => {
  return dateFormat(new Date().getTime(), 'YYYY-MM') > month;
};

/**
 * 将问卷题目整理为字符串
 * @param {*} questionArr
 */
export const dealQuestionnaire = questionArr => {
  // 需要选项文本的题目类型
  const needOptionsType = [1, 2, 3, 5];
  return questionArr
    .reduce((pre, cur) => {
      // 格式话json字符串
      try {
        pre.push(JSON.parse(cur));
      } catch (err) {
        console.error(err);
      }
      return pre;
    }, [])
    .sort((a, b) => {
      // 按照type排序
      if (a.type > b.type) {
        return 1;
      } else {
        return -1;
      }
    })
    .reduce((pre, cur) => {
      // 整合字符串
      const { title, optionJson, type } = cur;
      pre += title;
      try {
        if (needOptionsType.includes(type)) {
          pre += JSON.stringify(optionJson);
        }
      } catch (err) {
        console.error(err);
      }
      return pre;
    }, '');
};

/**
 * 判断当前问卷重合度是否为高
 */
export const checkQuestionnaireIsAlike = async function({
  projectId = 0,
  projectType = 0,
  webStr = '',
  checkAjax = checkQuestionnaireIsAlikeAjax,
  callback
}) {
  const h = this.$createElement;
  const dialog = () => {
    return new Promise((resolve, reject) => {
      xrkDialogJs({
        title: '提示',
        width: '400px',
        $slots: {
          default: h('div', {}, [
            h('div', {}, [
              h('span', '您当前提交的调研问卷重合率度：'),
              h(
                'span',
                {
                  style: 'color:red;'
                },
                '高'
              )
            ]),
            h(
              'div',
              '若以当前问卷进行提交审核，有可能无法通过平台运营审核。请您确认是否继续保存。'
            )
          ]),
          footer: h('div', { class: 'xrk-dialog__btns' }, [
            h(
              'el-button',
              {
                props: {
                  type: 'info'
                },
                on: {
                  click: reject
                }
              },
              '取消'
            ),
            h(
              'el-button',
              {
                props: {
                  type: 'primary'
                },
                on: {
                  click: resolve
                }
              },
              '确定'
            )
          ])
        }
      });
    });
  };
  if (Object.prototype.toString.call(callback) != '[object Function]') {
    console.warn('checkQuestionnaireIsAlike方法需传入callback函数');
    return;
  }
  const {
    data: { data }
  } = await checkAjax({
    projectId,
    projectType,
    webStr
  });
  if (data > 0.5) {
    dialog()
      .then(() => {
        xrkDialogJs.remove();
        //问卷重合率提示确定
        callback(true);
      })
      .catch(() => {
        xrkDialogJs.remove();
        //问卷重合率提示取消
        callback(false);
      });
  } else {
    //重合率不高则视为确定
    callback(true);
  }
};

/**
 * 判断当前问卷是否会重置BI
 */
export const checkCopyProjectBIConfigs = async function({
  projectId = 0,
  tips,
  checkAjax = checkCopyProjectBIConfigsAjax,
  callback,
  getAjaxResp = false
}) {
  const h = this.$createElement;
  const dialog = msg => {
    return new Promise((resolve, reject) => {
      xrkDialogJs({
        title: '提示',
        width: '400px',
        $slots: {
          default: h('div', {}, [h('span', tips && tips(msg))]),
          footer: h('div', { class: 'xrk-dialog__btns' }, [
            h(
              'el-button',
              { props: { type: 'info' }, on: { click: reject } },
              '取消'
            ),
            h(
              'el-button',
              { props: { type: 'primary' }, on: { click: resolve } },
              '确定'
            )
          ])
        }
      });
    });
  };
  if (
    !getAjaxResp &&
    Object.prototype.toString.call(callback) != '[object Function]'
  ) {
    console.warn('checkQuestionnaireIsAlike方法需传入callback函数');
    return;
  }
  const {
    data: {
      data: { isExists, items }
    }
  } = await checkAjax({ projectId });
  if (!getAjaxResp) {
    if (isExists && items) {
      dialog(items)
        .then(() => {
          xrkDialogJs.remove();
          callback(true);
        })
        .catch(() => {
          xrkDialogJs.remove();
          callback(false);
        });
    } else {
      callback(true);
    }
  }
  return { isExists, items };
};

export const confirmDialog = async params => {
  let args = {
    content: '请在新打开的页面完成签约，签约成功请点击完成',
    title: '提示',
    options: {},
    cb: () => {},
    ...params
  };
  let { content, title, options, cb } = args;
  try {
    await MessageBox.confirm(content, title, {
      confirmButtonText: '完成',
      cancelButtonText: '取消',
      type: 'warning',
      ...options
    });
    cb();
  } catch (e) {
    console.error('confirmDialog error: ', e);
    Message({
      type: 'info',
      message: '已取消'
    });
  }
};

export function formatDecimal(num, decimal) {
  num = num.toString();
  let index = num.indexOf('.');
  if (index !== -1) {
    num = num.substring(0, decimal + index + 1);
  } else {
    num = num.substring(0);
  }
  return parseFloat(num).toFixed(decimal);
}

export function copy(className) {
  const clipboard = new Clipboard(`.${className}`);
  clipboard.on('success', () => {
    Message({
      message: '复制成功',
      type: 'success'
    });
    clipboard.destroy();
  });
  clipboard.on('error', () => {
    Message({
      message: '复制失败',
      type: 'warning'
    });
    clipboard.destroy();
  });
}

/**
 *
 * @param {homeProject} 传入store中存储的homeProject
 * @returns
 */
export const checkNeedUserTag = ({ projectType, fileUpMode, type }) => {
  if (type == 2) {
    // 医生汇
    return false;
  }

  // fileUpMode 1活动维度 2人维度
  if (projectType == 19 && fileUpMode == 1) {
    // 协定服务 活动类型
    return false;
  }
  return true;
};

export const updateVersion = async () => {
  const toVersion = v => {
    return (v + '').replace(/\./g, '');
  };
  const { VUE_APP_SCENE, VUE_APP_VERSION } = process.env;
  if (['online', 'pro-pre'].includes(VUE_APP_SCENE)) {
    const {
      pdata: { version, isOpen, isForceUpdate }
    } = await clientVersion.getVersion();
    let localV = toVersion(VUE_APP_VERSION);
    let onlineV = toVersion(version);
    const maxLen = Math.max(localV.length, onlineV.length);
    localV = +localV.padEnd(maxLen, '0');
    onlineV = +onlineV.padEnd(maxLen, '0');
    if (isOpen && isForceUpdate && onlineV > localV) {
      const path = window.location.href.split('/#/')[1];
      window.location.href = `${window.location.origin}?version=${version}/#/${path}`;
    }
  }
};
/**
 * @description: 打开新版本BI
 * @param {number} id biInfoId
 * @param {string} isEdit 0不可编辑，1可编辑
 * @param {string} platform 打开平台 默认当前平台
 * @param {number} selectType 201当期 202累计 203自定义 。注意，新版老版该字段不一致。老版为：新UI接口调用之前的
 * @param {number} projectType 项目类型
 */
export const openV3BI = ({
  id,
  selectType = 201,
  isEdit = '1',
  platform = 'asp',
  projectType = 0,
  projectId
}) => {
  window.open(
    `${Config.biUrl}?id=${id}&isEdit=${isEdit}&platform=${platform}&selectType=${selectType}&projectType=${projectType}&projectId=${projectId}`,
    '_blank'
  );
};
/**
 * @description: 预览文件,无image。pdf使用cdn，其他使用永中。永中第一次加载太慢，正在修复
 * @param {string} url 文件地址
 */
export const previewFile = url => {
  if (/.zip/.test(url)) {
    window.open(url);
    return;
  }
  if (/.pdf/.test(url)) {
    window.open(
      `https://cdn.yxvzb.com/WEB/SaaS/utils/pdfjs/web/viewer.html?file=${url}`
    );
    return;
  }
  url = url.replace('yiyang.oss-cn-beijing.aliyuncs.com', 'cdn.yxvzb');
  url = url.replace(/http:|https:/, window.location.protocol);
  window.open(`${Config.fileViewUrl}?t=${Date.now()}&url=${url}`);
};
